<script setup>
/******************************************************************************
 * PageComponent: ReadingReqCustomer
 *****************************************************************************/
import { useReadingStore } from "Stores/reading";
import { useAppStore } from "Stores/app";
import ReadingReqDone from "./ReadingReqDone.vue";
import ReadingReqCustomerHeader from "./ReadingReqCustomerHeader.vue";
import FormNavRow from "Components/Form/FormNavRow.vue";
import FormButton from "Components/Form/FormButton.vue";
import FormGlobalErrorMessages from "Components/Form/FormGlobalErrorMessages.vue";
import ReadingReqEmail from "./ReadingReqEmail.vue";
import { ref } from "vue";
const appStore = useAppStore();
const props = defineProps({
    customer: {
        type: Object,
        required: true,
    },
});
const readingStore = useReadingStore();
const onSubmit = () => {
    readingStore.submitReadingReqOutputChannel(
        props.customer.customerNo,
        props.customer.customerId,
        props.customer.clientId,
        2, // change to "email"
        newEmail.value
    );
};
const newEmail = ref(props.customer.eMail);
const onChange = (value) => {
    newEmail.value = value;
};
</script>

<template>
    <li class="customer">
        <reading-req-customer-header :customer="props.customer" />
        <form
            v-if="!props.customer.readingReqChannelDone"
            @submit.prevent="onSubmit"
        >
            <reading-req-email
                :email="props.customer.eMail"
                :customer-no="props.customer.customerNo"
                :client-id="props.customer.clientId"
                @change="onChange"
            />
            <form-global-error-messages
                v-if="props.customer.readingReqChannelError.length > 1"
                :error-text="props.customer.readingReqChannelError"
                :top="0.5"
            />
            <form-nav-row v-if="newEmail" :top="0.5">
                <template #forward>
                    <form-button
                        text="Änderung übernehmen"
                        icon-position="right"
                        icon-name="send"
                        importance="default"
                        :disabled="appStore.requesting"
                    />
                </template>
            </form-nav-row>
        </form>
        <reading-req-done v-else :customer-id="props.customer.customerId" />
    </li>
</template>

<style lang="scss" scoped>
.customer {
    padding: #{get($sizes, "base") * 0.5};

    background-color: get($client, "outputChannelCustomerBg");
    color: get($client, "outputChannelCustomerColor");
    border-radius: get($sizes, "radius");

    @include respond-to("medium") {
        padding: #{get($sizes, "base") * 1};
    }
}

.customer-no cite {
    color: palette("brand1", "color");

    font-style: normal;
}
</style>
